import {Icon} from "@client/components/Icon";
import * as constants from "@client/constants";
import * as router from "@client/router";
import * as analytics from "@client/shared/analytics";
import * as typography from "@client/shared/typography";
import * as utils from "@client/utils";
import {classNames} from "@reactivated";
import * as React from "react";

const styles = {
    grid: "justify-items-center grid grid-cols-1 gap-[30px] md:grid-cols-3",
    spacer: "space-y-[15px] flex flex-col",
    tutorial: "space-y-2.5",
    video: "tutorials-video relative",
    playing: "tutorials-playing",
} as const;

const TutorialsGrid = () => {
    const staticURL = utils.getStaticBucketURL();
    const [playing, setPlaying] = React.useState<string | null>(null);

    const handleOnClick = (tutorial: string) => {
        if (tutorial === playing) {
            setPlaying(null);
        } else {
            void analytics.track("PLAY_TUTORIAL", {tutorial_name: tutorial});
            setPlaying(tutorial);
        }
    };

    return (
        <div className={styles.spacer}>
            <div className={styles.grid}>
                {constants.TUTORIALS.map(([description, tutorial]) => (
                    <div key={tutorial} className={styles.tutorial}>
                        <typography.Subtitle>{description}</typography.Subtitle>
                        <link
                            rel="preload"
                            as="image"
                            href={`${staticURL}videos/${tutorial}.mov.gif`}
                        />
                        <div
                            className={classNames(
                                styles.video,
                                tutorial === playing && styles.playing,
                            )}
                        >
                            <img
                                src={
                                    playing === tutorial
                                        ? `${staticURL}videos/${tutorial}.mov.gif`
                                        : `${staticURL}videos/cover-${tutorial}.mov.gif`
                                }
                            />
                            {tutorial !== playing && (
                                <button onClick={() => handleOnClick(tutorial)}>
                                    <Icon large="relative" icon="0875-play-circle" />
                                </button>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export const Tutorials = router.Tutorials.withHooks(() => ({}))
    .withIndex(() => <TutorialsGrid />)
    .withActions(() => [])
    .withOptions(() => ({
        title: "Tutorials",
    }));
